import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import AboutHero from "./components/AboutHero";
import AboutStory from "./components/AboutStory";
import Timeline from "./components/Timeline";
import AboutStats from "./components/AboutStats";
import AboutWhatsAppSection from "./components/WhatsAppSection";

export default function AboutPage() {
  useEffect(() => {
    document.title =
      "About Urban Infra | Trusted Real Estate Developer Karnataka | UrbanInfraProjects.in";

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        if (prop) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Learn about Urban Infra — Karnataka's trusted real estate developer since 2016. 9+ eco-friendly gated community layouts and villa plot projects with honest, transparent property development. Visit UrbanInfraProjects.in."
    );
    setMeta("keywords", "Urban Infra about, real estate developer Karnataka, villa plots developer, UrbanInfraProjects.in");
    setMeta("og:title", "About Urban Infra | Trusted Real Estate Developer Karnataka", true);
    setMeta("og:description", "Urban Infra — Karnataka's trusted real estate developer since 2016. 9+ eco-friendly gated community layouts and villa plots.", true);
    setMeta("og:url", `${import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in"}/about`, true);
    setMeta("og:site_name", "Urban Infra", true);
    setMeta("og:type", "website", true);

    // Schema.org JSON-LD — Organization
    const schemaId = "schema-about";
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = schemaId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Urban Infra",
      url: siteUrl,
      foundingDate: "2016",
      description:
        "Urban Infra is a Karnataka-based real estate developer specializing in eco-friendly villa plots and gated community layouts across Karnataka.",
      telephone: "+919945124133",
      email: "sales@urbaninfraproject.in",
      address: {
        "@type": "PostalAddress",
        streetAddress: "#2, CNR Complex, First Floor, Muthanallur Cross, Sarjapur Main Road",
        addressLocality: "Bangalore",
        addressRegion: "Karnataka",
        postalCode: "562125",
        addressCountry: "IN",
      },
      areaServed: "Bengaluru",
    });

    window.scrollTo(0, 0);
    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <SiteHeader />
      <main>
        <AboutHero />
        <AboutStory />
        <AboutStats />
        <Timeline />
        <AboutWhatsAppSection />
      </main>
      <SiteFooter />
    </div>
  );
}
